import styled from 'styled-components';

export const HomeStyle = styled.div`
    /* height:100%;*/
    min-width:1200px; 
    width:100%;

    background:#C9F2FF;

    @media screen and (max-width: 1200px) {
        
        .wrapper{
            width:80%!important;
        }

    }
    
    .home-kfpt{
        display:flex;
        flex-direction:column;
        align-items:center;
        overflow:hidden;
        
        background:#C9F2FF;

        .home-header{
            /* width:1920px; */
            width:100%;
            height:94px;

            background:url(${require('images/home/top.png')}) no-repeat center top;
            background-size:cover;

            .wrapper{
                display:flex;
                justify-content:space-between;
                align-items:center;

                margin:0 auto;
                width:1000px;
                height:94px;

                .home-logo{
                    margin-left:18px;
                    width:197px;
                    height:66px;

                    cursor: pointer;
                }

                .home-header-right{
                    display:flex;
                    align-items:center;

                    .entry{
                        font-size:16px;
                        font-family:SourceHanSansCN-Bold,SourceHanSansCN;
                        font-weight:bold;
                        color:rgba(255,255,255,1);
                        cursor: pointer;
                    }

                    .down{
                        display:flex;
                        justify-content:center;
                        align-items:center;

                        width:111px;
                        height:39px;
                        margin-left:82px;
                        margin-right:31px;

                        background:rgba(255,255,255,1);
                        box-shadow:0px 2px 5px 0px rgba(118,199,236,1);
                        border-radius:20px;
                        font-size:18px;
                        font-family:SourceHanSansCN-Medium,SourceHanSansCN;
                        font-weight:500;
                        color:rgba(115,209,254,1);
                        cursor: pointer;
                    }
                }
            }
        }

        .wrapper1{
            margin:0 auto;
            width:1000px;

            .home-banner{
                position: relative;
                overflow:hidden;

                margin-top:20px;
                width:100%;
                height:366px;
                
                .banner-tol{
                    position: absolute;
                    top:167px;
                    left:15px;
                    z-index:10;

                    width:30px;
                    height:30px;
                    cursor: pointer;
                }

                .banner-tor{
                    position: absolute;
                    top:167px;
                    right:15px;
                    z-index:10;

                    width:30px;
                    height:30px;
                    cursor: pointer;
                }

                .banner-list{
                    position: absolute;
                    top:0;
                    left:0;
                    z-index:1;
                    display:flex;
                    align-items:center;

                    width:8000px;
                    height:366px;
                    
                    /* background:lightgray; */

                    .banner-item{
                        /* position: absolute;
                        top:0;
                        left:0; */
                        width:1000px;
                        height:366px;
                        border-radius:10px;
                        cursor: pointer;
                    }

                    .slider-others{
                        width:465px;
                        height:218px;
                    }

                    .slider-middle{
                        width:780px;
                        height:366px;
                    }

                }

            }

            .home-main{
                display:flex;
                flex-direction:column;

                width:100%;
                margin-top:45px;
                
                .home-item{
                    display:flex;
                    flex-direction:column;

                    .home-main-title{
                        margin:15px 0 25px;

                        font-size:20px;
                        font-family:PingFangSC-Medium,PingFang SC;
                        font-weight:500;
                        color:rgba(51,51,51,1);
                    }

                    .home-list{
                        display:flex;
                        flex-wrap:wrap;
                        /* justify-content:space-between; */

                        .item{
                            display:flex;
                            flex-direction:column;
                            position: relative;

                            margin-bottom:15px;
                            margin-right:40px;
                            width:220px;
                            
                            .item-img{
                                width:220px;
                                height:220px;
                                border-radius:10px;
                            }

                            .text{
                                margin:10px 0 5px;
                                /* height:22px; */
                                font-size:16px;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(51,51,51,1);
                                line-height:22px; 
                            }

                            .intro{
                                /* height:17px; */
                                font-size:12px;
                                font-family:PingFangSC-Regular,PingFang SC;
                                font-weight:400;
                                color:rgba(153,153,153,1);
                                line-height:17px;
                            }

                            .can{
                                position: absolute;
                                top:0;
                                left:0;

                                width:37px;
                                height:35px;
                            }
                        }
                    }
                }
            }
            
        }

        .home-footer{
            display:flex;
            flex-direction:column;
            align-items:center;

            /* width:1920px; */
            width:100%;
            height:632px;
            padding-top:380px;
            margin-top:-200px;

            background:url(${require('images/home/bottom.png')}) no-repeat center bottom;
            background-size:cover;

            .footer-top{
                display:flex;
                align-items:center;
                
                .word1{
                    width:273px;
                    /* height:101px; */

                    font-size:14px;
                    font-family:SourceHanSansCN-Medium,SourceHanSansCN;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    line-height:25px;
                }

                .word2{
                    margin:0 139px 0 97px;
                    width:194px;
                    height:101px;

                    font-size:14px;
                    font-family:SourceHanSansCN-Medium,SourceHanSansCN;
                    font-weight:500;
                    color:rgba(255,255,255,1);
                    line-height:25px;
                }

                .footer-i{
                    display:flex;
                    flex-direction:column;
                    align-items:center;

                    >img{
                        width:94px;
                        height:94px;
                        background:rgba(255,255,255,1);
                    }

                    .text{
                        margin-top:10px;
                        /* width:54px;
                        height:14px; */

                        font-size:14px;
                        font-family:SourceHanSansCN-Normal,SourceHanSansCN;
                        font-weight:400;
                        color:rgba(255,255,255,1);
                        line-height:21px;
                    }
                }

            }

            .footer-bottom{
                display:flex;
                align-items:center;
                justify-content:center;

                .foot-tip{
                    font-size:14px;
                    font-family:SourceHanSansCN-Normal,SourceHanSansCN;
                    font-weight:400;
                    color:rgba(255,255,255,1);
                }
            }
        }
    }

    .mask{
        position: fixed;
        top:0;
        left:0;
        z-index:12;

        width:100%;
        height:100%;

        .mask-dg{
            width:100%;
            height:100%;
        }

        .mask-con{
            position: absolute;
            top:200px;
            left:0;
            right:0;
            margin:0 auto;
            z-index:100;
            display:flex;
            flex-direction:column;
            align-items:center;

            width:350px;
            height:353px;

            background:rgba(255,255,255,1);
            box-shadow:0px 2px 22px 0px rgba(0,0,0,0.03);
            border-radius:14px;

            .icon{
                margin-top:-108px;
                width:123px;
                height:125px;
            }

            .title{
                /* margin:12px 0 18px; */

                font-size:20px;
                font-family:PingFangSC-Medium,PingFang SC;
                font-weight:500;
                color:rgba(51,51,51,1);
            }

            .down{
                margin:20px 0 16px;
                width:250px;
                height:250px;
                
                background:rgba(216,216,216,1);
                border-radius:13px;
            }

            .close{
                position: absolute;
                top:13px;
                right:13px;

                width:16px;
                height:16px;
                cursor: pointer;
            }
        }
    }

    /* @media screen and (max-width: 1024px) {
        .wrapper {
            width:80%!important;
        }
    } */
`;